var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2251 0.772249L15.2255 0.772611C15.5923 1.13946 15.5858 1.73995 15.2398 2.08596L8.66259 8.6632L8.66223 8.66356C8.57611 8.74986 8.47381 8.81833 8.36119 8.86505C8.24857 8.91176 8.12784 8.93581 8.00592 8.93581C7.88399 8.93581 7.76326 8.91176 7.65065 8.86505C7.53803 8.81833 7.43573 8.74986 7.3496 8.66356L7.34924 8.6632L0.772002 2.08596C0.597842 1.9118 0.500001 1.67559 0.500001 1.42929C0.500001 1.18298 0.597842 0.946771 0.772002 0.772611C0.946163 0.59845 1.18238 0.500607 1.42868 0.500607C1.67498 0.500607 1.91119 0.598449 2.08535 0.772611L7.6452 6.33245L7.99875 6.68601L8.35231 6.33245L13.9121 0.772611L13.9125 0.772249C13.9986 0.685947 14.1009 0.617478 14.2136 0.570762C14.3262 0.524046 14.4469 0.5 14.5688 0.5C14.6907 0.5 14.8115 0.524046 14.9241 0.570762C15.0367 0.617478 15.139 0.685947 15.2251 0.772249Z",
    fill: "black",
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down_arrow.41932465397de48744b668bf867b2195.svg";
export { ForwardRef as ReactComponent };